"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceEstimateResponseToJSON = exports.AudienceEstimateResponseFromJSONTyped = exports.AudienceEstimateResponseFromJSON = exports.instanceOfAudienceEstimateResponse = void 0;
var runtime_1 = require("../runtime");
var AudienceForecastInner_1 = require("./AudienceForecastInner");
/**
 * Check if a given object implements the AudienceEstimateResponse interface.
 */
function instanceOfAudienceEstimateResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceEstimateResponse = instanceOfAudienceEstimateResponse;
function AudienceEstimateResponseFromJSON(json) {
    return AudienceEstimateResponseFromJSONTyped(json, false);
}
exports.AudienceEstimateResponseFromJSON = AudienceEstimateResponseFromJSON;
function AudienceEstimateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceForecast': !(0, runtime_1.exists)(json, 'audience_forecast') ? undefined : (json['audience_forecast'].map(AudienceForecastInner_1.AudienceForecastInnerFromJSON)),
        'likelyToDeliverBudget': !(0, runtime_1.exists)(json, 'likely_to_deliver_budget') ? undefined : json['likely_to_deliver_budget'],
    };
}
exports.AudienceEstimateResponseFromJSONTyped = AudienceEstimateResponseFromJSONTyped;
function AudienceEstimateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audience_forecast': value.audienceForecast === undefined ? undefined : (value.audienceForecast.map(AudienceForecastInner_1.AudienceForecastInnerToJSON)),
        'likely_to_deliver_budget': value.likelyToDeliverBudget,
    };
}
exports.AudienceEstimateResponseToJSON = AudienceEstimateResponseToJSON;
